import moment from "moment";
// export const getCountries = async () => {
//   try {
//     const token = localStorage.getItem('token');
//     if (!token) return [];
    
//     const response = await fetch(
//       `${process.env.REACT_APP_API_BASE_URL}/api/country`,
//       {
//         method: 'GET',
//         headers: {
//           authorization: `bearer ${token}`,
//         },
//       },
//     );
    
//     const data = await response.json();
//     const fetchedCountries = data?.body?.countries || [];
    
//     // Map to the required structure { name, flag }
//     return fetchedCountries.map(ct => {
//       // Assuming countryCode is the ISO2 code, e.g., "AF", "NZ"
//       const iso2 = ct.countryCode; 
//       return {
//         _id: ct._id,
//         name: ct.name,
//         // Using w320 like the static list usually had, or just .svg as requested
//         // User requested: https://flagcdn.com/${iso2.toLowerCase()}.svg
//         flag: iso2 ? `https://flagcdn.com/${iso2.toLowerCase()}.svg` : '',
//         code: ct.countryCode,
//         dial_code: ct.dialCode
//       };
//     });
//   } catch (error) {
//     console.error('Error fetching countries:', error);
//     return [];
//   }
// };

// export const countries = [
//   { name: "Australia", flag: "https://flagcdn.com/w320/au.png" },
//   { name: "USA", flag: "https://flagcdn.com/w320/us.png" },
//   { name: "UK", flag: "https://flagcdn.com/w320/gb.png" },
//   { name: "Europe", flag: "https://upload.wikimedia.org/wikipedia/commons/b/b7/Flag_of_Europe.svg" },
//   { name: "Canada", flag: "https://flagcdn.com/w320/ca.png" },
//   { name: "New Zealand", flag: "https://flagcdn.com/w320/nz.png" },
//   { name: "Japan", flag: "https://flagcdn.com/w320/jp.png" },
//   { name: "UAE", flag: "https://flagcdn.com/w320/ae.png" },
//   // { name: "Thailand", flag: "https://flagcdn.com/w320/th.png" },
// ]; 

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCountries, fetchVisaTypes } from "../../../redux/features/filterSlice";

export const useCountries = () => {
  const dispatch = useDispatch();
  const { countries, countriesStatus } = useSelector((state) => state.filters);

  useEffect(() => {
    if (countriesStatus === 'idle') {
      dispatch(fetchCountries());
    }
  }, [dispatch, countriesStatus]);

  return countries;
};


// export const visaCategories = [
  // "Visit Visa",
  // "Study Visa",
  // "485 Visa",
  // "Spouse Visa",
  // "GSM ( 491,190,189) Visa",
  // "AAT Visa",
  // "Protection",
//   "Visit Visa",
//   "Study Visa",
//   "Temporary Graduate Visa",
//   "Permanent Residence",
//   "Spouse Visa",
//   "General Skilled Migration - GSM (491,190,189)",
//   "Protection Visa",
//   "Australian Resident Transition (ART)",
//   "Federal Circuit Court Appeals",
//   "Employer Sponsored Visas (407,482,186)",
//   "Skill Assesment"
// ];

export const visaCategories = [
  { label: "Visit Visa", value: "Visit Visa" },
  { label: "Study Visa", value: "Study Visa" },
  { label: "Temporary Graduate Visa", value: "485 Visa" },
  { label: "Permanent Residence", value: "Permanent Residence" },
  { label: "Spouse Visa", value: "Spouse Visa" },
  { label: "General Skilled Migration - GSM (491,190,189)", value: "GSM ( 491,190,189) Visa" },
  { label: "Protection Visa", value: "Protection" },
  { label: "Australian Resident Transition (ART)", value: "ART Visa" },
  { label: "Federal Circuit Court Appeals", value: "FCC Appeals" },
  { label: "Employer Sponsored Visa (407,482,186)", value: "ES Visa" },
  { label: "Skill Assesment", value: "Skill Assesment" }
];

export function getVisaLabelByValue(value) {
  const category = visaCategories.find(item => item.value === value);
  return category ? category.label : null;
}

export function getVisaValueByLabel(label) {
  const category = visaCategories.find(item => item.label === label);
  return category ? category.value : null;
}

// export const visaCategoriesFilter = [
//   "All",
//   "Visit Visa",
//   "Study Visa",
//   "485 Visa",
//   "Spouse Visa",
//   "GSM ( 491,190,189) Visa",
//   "AAT Visa",
//   "Protection",
// ];

export const visaCategoriesFilter = [
  "All",
  "Visit Visa",
  "Study Visa",
  "Temporary Graduate Visa",
  "Permanent Residence",
  "Spouse Visa",
  "General Skilled Migration - GSM (491,190,189)",
  "Protection Visa",
  "Australian Resident Transition (ART)",
  "Federal Circuit Court Appeals",
  "Employer Sponsored Visa (407,482,186)",
  "Skill Assesment",
];

export const useVisaTypeFilters = () => {
  const dispatch = useDispatch();
  const { visaTypes, visaTypesStatus, countriesStatus } = useSelector((state) => state.filters);
  // We also need to listen to globalCountries changes to re-fetch if needed.
  // Assuming globalCountries is in state.globalCountries (from countriesSlice)
  const globalCountries = useSelector((state) => state.globalCountries.globalCountries);

  // Trigger fetch for countries if not started (handled by useCountries usage elsewhere or dispatched here)
  useEffect(() => {
    if (countriesStatus === 'idle') {
      dispatch(fetchCountries());
    }
  }, [dispatch, countriesStatus]);

  // Fetch Visa Types
  useEffect(() => {
    // Check if we need countries
    const savedCountries = localStorage.getItem("globalCountries");
    let needsCountries = false;
    try {
      const p = JSON.parse(savedCountries);
      if (Array.isArray(p) && p.length > 0) needsCountries = true;
    } catch (e) {}

    // If we need countries but they are not loaded, wait.
    if (needsCountries && countriesStatus !== 'succeeded') {
      return;
    }

    // Only fetch if idle or if we want to force refresh on globalCountries change?
    // Using simple approach: if idle, fetch.
    // If globalCountries changes, we might want to reset visaTypesStatus to idle?
    // But we don't have an action for that exposed yet.
    // For now, adhere to "add into this" and Redux usage.
    
    if (visaTypesStatus === 'idle') {
      dispatch(fetchVisaTypes());
    }
  }, [dispatch, visaTypesStatus, countriesStatus, globalCountries]); 
  // Added globalCountries to dependency array to trigger effect, 
  // but it won't dispatch if status is not 'idle'. 
  // To handle updates, we'd need a way to invalidate cache. 
  // I will assume for now that standard fetching (once) is sufficient or user will reload.

  return visaTypes;
};

// Static visa type filters for Leads, Client History, and Application Log screens
// export const staticVisaTypeFilters = [
//   "All",
//   "Study Visa",
//   "Visit Visa",
//   "485 Visa",
//   "Spouse Visa",
//   "GSM ( 491,190,189) Visa",
//   "ART Visa",
//   "Protection",
//   "Skill Assesment",
//   "ES Visa",
//   "FCC Appeals",
//   "Permanent Residence"
// ];

export const months = [
  { value: "1", name: "January" },
  { value: "2", name: "February" },
  { value: "3", name: "March" },
  { value: "4", name: "April" },
  { value: "5", name: "May" },
  { value: "6", name: "June" },
  { value: "7", name: "July" },
  { value: "8", name: "August" },
  { value: "9", name: "September" },
  { value: "10", name: "October" },
  { value: "11", name: "November" },
  { value: "12", name: "December" },
];

export const years = Array.from(
  { length: moment().year() - 2024 + 1 },
  (_, index) => (2024 + index).toString()
);
